import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {RequestFormType} from "../../../app/tools/request-forms2/const/const";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../app/settings/const";
import {QuickAddItemType} from "../../../app/quick-add/@types";


export class RequestsModule extends ModuleProto {

    constructor(moduleConfig:JSONObject) {
        super(ModuleType.REQUESTS, moduleConfig);

        this.name                    = "Requests"
        this.description             = "The Requests module streamlines the process of collecting and managing various types of requests within your organization."
        this.svgIcon                 = "isvg-request"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel               = "Productivity & collaboration"
        this.settingsUrl             = "settings/requests"
        this.parentSection          = SettingsParentSection.PRODUCTIVITY

        this.feature                = Feature.FORMS
        this.validateFeature()

    }

    toJson() {
        const result = super.toJson();
        return result
    }


    // Helper functions

    newRequestForm(projectId?:ID) {
        gd.openNew(QuickAddItemType.REQUEST_FORM, {type: RequestFormType.REQUEST, projectId});
    }

    goToSettings() {
        gd.goTo('settings/requests')
    }

    goToList() {
        gd.goTo('o/requests')
    }

}